import React, { useEffect, useState } from 'react';
import api, { dispatchAPI, apiBaseUrl } from '../../../utils/api';
import DataTable from '../../../components_shared/DataTable';
import { Modal } from 'react-bootstrap';

export default function QCReceiptPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // modal state
  const [show,setShow]=useState(false);
  const [currentId,setCurrentId]=useState(null);
  const [remarks,setRemarks]=useState('');
  const [sigFile,setSigFile]=useState(null);
  const [sigError,setSigError]=useState('');
  const [existingSig,setExistingSig]=useState(null);
  const [useExisting,setUseExisting]=useState(false);

  const openModal=async (id)=>{
      setCurrentId(id);
      setRemarks(''); setSigFile(null); setSigError(''); setExistingSig(null); setUseExisting(false);
      try{
        const res = await api.get('/api/v1/inventory/signature/me',{responseType:'blob'});
        const url = URL.createObjectURL(res.data);
        setExistingSig(url);
        setUseExisting(true);
      }catch(e){ /* no existing sig */ }
      setShow(true);
  };
  const closeModal=()=>setShow(false);

  const fetchRows = async () => {
    try {
      const res = await api.get('/api/v1/inventory/dispatch-notes'); // load all
      const all = res.data?.content || [];
      const filtered = all.filter(dn => ['IN_QC','ARRIVED_GATE'].includes(dn.status));
      setRows(filtered);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchRows(); }, []);

  const columns = [
    { accessorKey: 'id', header: 'DN ID' },
    { accessorKey: 'workOrderNo', header: 'Work Order' },
    { accessorKey: 'quantity', header: 'Qty' },
    { accessorKey: 'truckNumber', header: 'Truck #' },
    {
      id:'actions',
      header:'Actions',
      cell:({row})=>{
        const s=row.original.status;
        if(s==='IN_QC') return <button className="eduss-btn-primary btn-sm" onClick={()=>openModal(row.original.id)}>Take Action</button>;
        if(s==='RECEIVED_FINAL') return <button className="btn btn-primary btn-sm" onClick={()=>window.open(`${apiBaseUrl}/api/v1/inventory/final-receipts/${row.original.id}/pdf`,'_blank')}>📄 Final Receipt</button>;
        return null;
      }
    },
  ];

  // action handler
  const handleAction = async (approve) => {
    if (!remarks.trim()) { setSigError('Remarks required'); return; }
    if (!sigFile && !(existingSig && useExisting)) { setSigError('Signature required'); return; }
    try {
      await dispatchAPI.qcAction(currentId, { remarks, approved: approve });
      closeModal();
      fetchRows();
    } catch (err) {
      alert(err.response?.data?.message || err.message);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="inventory-page">
      <div className="premium-card inventory-page-card">
        <h2>Quality Inspection</h2>
        <DataTable data={rows} columns={columns} />
      </div>

      <Modal show={show} onHide={closeModal} centered>
        <Modal.Header closeButton><Modal.Title>Dispatch Note #{currentId}</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="mb-3"><label className="form-label">Remarks</label>
            <textarea className="form-control" value={remarks} onChange={e=>setRemarks(e.target.value)} required></textarea>
          </div>
          <div className="mb-3"><label className="form-label">Signature (PNG)</label>
            {existingSig && !sigFile && (
              <div className="mb-2" style={{cursor:'pointer'}} onClick={()=>setUseExisting(prev=>!prev)}>
                <img src={existingSig} alt="signature"
                 style={{maxWidth:'100%',maxHeight:120,border: useExisting?'2px solid #0d6efd':'1px solid #ccc'}}/>
                <small className="text-muted">{useExisting?'Selected':'Click to select'}</small>
              </div>) }
            <input type="file" accept="image/png" className="form-control" onChange={e=>{setSigFile(e.target.files[0]); setSigError(''); setUseExisting(false);}} />
            {sigError && <div className="text-danger small">{sigError}</div>}
          </div>
          <div className="mb-2 text-muted">{new Date().toLocaleString()}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={()=>handleAction(false)}>Reject</button>
          <button className="btn btn-success" onClick={()=>handleAction(true)}>Approve</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
